import {Injectable, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/interval';
import {Http, Headers, Response, RequestOptions, URLSearchParams} from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class LoggerService implements OnInit{
  /**
   * Review
   * Todo:
   * Неиспользуемые переменные
   */

  constructor(private http: Http, public router: Router) {

  }

  ngOnInit(){}

  public getFiles(password: number): Observable<any> {
    return this.http.get(`/api/logs?password=${password}`).map(data => data.json());
  };

  public removeFiles(name: string, password: number): Observable<any> {
    return this.http.delete(`/api/logs/${name}?password=${password}`).map(data => data.json());
  };

  public async getLog(log: any): Promise<any>  {
    return await this.http.get(log.path).toPromise().then(function (data: any) {
      if (data._body) {
        return data._body;
      }
      return ''
    })
  };

}





// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/services/logger.service.ts